//#region IMPORT
import React, { useEffect } from 'react';
import { BusinessGridCommon } from '../../../../Components/BusinessGridCommon';
import { useSelector } from 'react-redux';
import { getColumnDefs1 } from './SUB_BASIC_02_ColumnDefs';

//#endregion

function SUB_BASIC_02(props) {
  const searchInfo = useSelector((state) => state.SearchInfo);
  // 적격수급인 평가서 그리드 컬럼
  const columnDefs1 = getColumnDefs1(props);

  //#region AuthButton 이벤트
  useEffect(() => {
    if (props.filterClick2) {
      if (!props.validateSelection()) {
        props.setFilterClick2(false);
        return;
      }

      props.gridRef1.current.api.setQuickFilter(searchInfo?.searchText || '');
      props.setFilterClick2(false);
    }
    if (props.searchClick2) {
      if (!props.validateSelection()) {
        props.setSearchClick2(false);
        return;
      }

      props.SearchLogic1();
      props.setSearchClick2(false);
    }
    if (props.saveClick2) {
      if (!props.validateSelection()) {
        props.setSaveClick2(false);
        return;
      }

      props.SaveLogic1();
      props.setSaveClick2(false);
    }
    if (props.printClick2) {
      if (!props.validateSelection()) {
        props.setPrintClick2(false);
        return;
      }

      props.PrintLogic1();
      props.setPrintClick2(false);
    }
    if (props.listClick2) {
      if (!props.validateSelection()) {
        props.setListClick2(false);
        return;
      }

      props.setModalToggle3(true);
      props.SearchLogic4();
      props.setListClick2(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.filterClick2,
    props.searchClick2,
    props.saveClick2,
    props.printClick2,
    props.listClick2,
  ]);
  //#endregion
  return (
    <React.Fragment>
      <BusinessGridCommon
        addYn1="N"
        deleteYn1="N"
        gridRef={props.gridRef1}
        editable={true}
        columnDefs={columnDefs1}
        rowData={props.rowData1}
        setSelectedRowData={props.setSelectedRowData1}
        setChangedRowData={props.setChangedRowData1}
        rowSelection={'single'}
        refreshClick1={() => {
          if (!props.validateSelection()) return;

          props.SearchLogic1();
          props.setSearchClick2(false);
        }}
      />
    </React.Fragment>
  );
}

export default SUB_BASIC_02;
